import { render } from "./AppChoiceMaker.vue?vue&type=template&id=528210ae&scoped=true"
import script from "./AppChoiceMaker.vue?vue&type=script&lang=js"
export * from "./AppChoiceMaker.vue?vue&type=script&lang=js"

import "./AppChoiceMaker.vue?vue&type=style&index=0&id=528210ae&lang=scss"
import "./AppChoiceMaker.vue?vue&type=style&index=1&id=528210ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528210ae"]])

export default __exports__